// 该文件install方法负责所有的公共组件的全局注册
// vue插件机制: Vue.use

export default {
  install(Vue) {
    // 自动注册全局组件
    const requireComponent = require.context(
      './', // 在当前目录下查找
      true, // 查询子目录
      /\w+\.vue$/ // 匹配以.vue结尾的文件
    )

    // 遍历找到的文件
    requireComponent.keys().forEach(fileName => {
      // 获取组件配置
      const componentConfig = requireComponent(fileName)
      // 获取组件名称
      const componentName = fileName
        .split('/')
        .pop()
        .replace(/\.vue$/, '')
        .replace(/^\w/, c => c.toLowerCase())

      // 全局注册组件
      Vue.component(componentName, componentConfig.default || componentConfig)
    })
  }
}